/**
 * HandCrafted Shoes - Storefront Interactivity Engine
 * Lightweight vanilla JavaScript without SPA framework overhead.
 */

document.addEventListener('DOMContentLoaded', () => {
  // --- Cart Drawer Toggles ---
  function openCart() {
    const drawer = document.getElementById('CartDrawer');
    const overlay = document.getElementById('CartDrawerOverlay');
    const panel = document.getElementById('CartDrawerPanel');
    if (!drawer) return;
    document.body.style.overflow = 'hidden';
    drawer.classList.remove('hidden', 'pointer-events-none');
    requestAnimationFrame(() => {
      overlay?.classList.remove('opacity-0');
      overlay?.classList.add('opacity-100');
      panel?.classList.remove('translate-x-full');
      panel?.classList.add('translate-x-0');
    });

    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'view_cart',
          ecommerce: {
            currency: cart.currency || 'INR',
            value: (cart.total_price || 0) / 100,
            items: (cart.items || []).map(function(item) {
              return {
                item_id: item.sku || item.variant_id,
                item_name: item.product_title || item.title,
                price: (item.final_price || item.price || 0) / 100,
                item_brand: 'HANDCRAFTED',
                item_category: item.product_type || 'Footwear',
                item_variant: item.variant_title,
                quantity: item.quantity
              };
            })
          }
        });
      })
      .catch(function() {});
  }

  function closeCart() {
    const drawer = document.getElementById('CartDrawer');
    const overlay = document.getElementById('CartDrawerOverlay');
    const panel = document.getElementById('CartDrawerPanel');
    if (!drawer) return;
    document.body.style.overflow = '';
    overlay?.classList.remove('opacity-100');
    overlay?.classList.add('opacity-0');
    panel?.classList.remove('translate-x-0');
    panel?.classList.add('translate-x-full');
    setTimeout(() => {
      drawer.classList.add('hidden', 'pointer-events-none');
    }, 300);
  }

  window.openCartDrawer = openCart;
  window.closeCartDrawer = closeCart;
  window.openCartModal = openCart;
  window.closeCartModal = closeCart;

  // --- Toast Notification System (React Sonner Parity) ---
  window.showToastNotification = function(title, description) {
    var container = document.getElementById('ToastContainer');
    if (!container) {
      container = document.createElement('div');
      container.id = 'ToastContainer';
      container.className = 'fixed top-6 left-1/2 -translate-x-1/2 z-[100] pointer-events-none flex flex-col items-center gap-2 w-full max-w-sm px-4';
      document.body.appendChild(container);
    }

    var toast = document.createElement('div');
    toast.className = 'pointer-events-auto bg-background text-foreground border border-border/80 shadow-2xl rounded-xl p-3.5 sm:p-4 flex items-start gap-3 w-full transform -translate-y-4 opacity-0 transition-all duration-300 ease-out';
    toast.innerHTML = `
      <span class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-leather text-cream mt-0.5">
        <svg class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="3">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
        </svg>
      </span>
      <div class="flex-1 min-w-0">
        <p class="font-serif text-sm font-semibold text-leather leading-tight">${title || 'Added to bag'}</p>
        ${description ? `<p class="text-xs text-muted-foreground mt-0.5 leading-snug truncate">${description}</p>` : ''}
      </div>
    `;

    container.appendChild(toast);

    requestAnimationFrame(function() {
      toast.classList.remove('-translate-y-4', 'opacity-0');
      toast.classList.add('translate-y-0', 'opacity-100');
    });

    setTimeout(function() {
      toast.classList.remove('translate-y-0', 'opacity-100');
      toast.classList.add('-translate-y-4', 'opacity-0');
      setTimeout(function() {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 300);
    }, 3500);
  };

  // Helper to show/hide loading spinner on checkout button during edits (without dimming panel)
  function setCartLoading(loading) {
    var checkoutBtn = document.getElementById('CartCheckoutBtn');
    if (loading) {
      if (checkoutBtn) {
        checkoutBtn.classList.add('opacity-90', 'pointer-events-none');
        checkoutBtn.innerHTML = '<svg class="h-4 w-4 animate-spin text-[#F9F6F0] mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>';
      }
    } else {
      if (checkoutBtn) {
        checkoutBtn.classList.remove('opacity-90', 'pointer-events-none');
      }
    }
  }

  // --- Cart UI Synchronization ---
  window.refreshCartUI = function(cart, openDrawer) {
    // 1. Update header badges (count non-warranty shoe items)
    var badges = document.querySelectorAll('.cart-count-badge');
    var displayCount = 0;

    if (cart && cart.items) {
      cart.items.forEach(function(item) {
        var isW = item.variant_id == 49024431718627 || item.variant_id == 49024431915235 || (item.product_type && item.product_type.toLowerCase() === 'warranty') || (item.title && (item.title.indexOf('Core Care') !== -1 || item.title.indexOf('Sole & Care Plan') !== -1));
        if (!isW) displayCount += item.quantity;
      });
    } else if (cart && typeof cart.item_count === 'number') {
      displayCount = cart.item_count;
    }

    badges.forEach(function(badge) {
      badge.textContent = displayCount;
      if (displayCount > 0) badge.classList.remove('hidden');
      else badge.classList.add('hidden');
    });

    // 2. Fetch section HTML from Shopify Section Rendering API
    var sectionUrl = window.location.pathname + '?section_id=cart-drawer';
    return fetch(sectionUrl)
      .then(function(res) { return res.text(); })
      .then(function(html) {
        var currentContent = document.getElementById('CartDrawerContent');
        if (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newContent = doc.getElementById('CartDrawerContent');

          if (currentContent && newContent) {
            currentContent.innerHTML = newContent.innerHTML;
          } else {
            var drawer = document.getElementById('CartDrawer');
            var fullNewDrawer = doc.querySelector('#CartDrawer');
            if (drawer && fullNewDrawer) {
              drawer.innerHTML = fullNewDrawer.innerHTML;
            }
          }

          if (openDrawer) {
            window.openCartDrawer();
          }
        }
        setCartLoading(false);
      })
      .catch(function(err) {
        console.error('Error refreshing cart UI:', err);
        setCartLoading(false);
      });
  };

  window.updateCartItemQty = function(id, quantity) {
    setCartLoading(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity })
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      window.refreshCartUI(cart);
    })
    .catch(function(err) {
      setCartLoading(false);
      console.error('Error updating cart:', err);
    });
  };

  window.removeProductLine = function(shoeKey, warrantyKey) {
    setCartLoading(true);
    var updates = {};
    if (shoeKey) updates[shoeKey] = 0;
    if (warrantyKey && warrantyKey !== 'null' && warrantyKey !== 'undefined') updates[warrantyKey] = 0;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      window.refreshCartUI(cart);
    })
    .catch(function(err) {
      setCartLoading(false);
      console.error('Error removing item:', err);
    });
  };

  window.changeShoeQty = function(shoeKey, newQty, warrantyKey, currentWarrantyQty, currentShoeQty) {
    if (newQty <= 0) {
      window.removeProductLine(shoeKey, warrantyKey);
      return;
    }
    setCartLoading(true);
    var updates = {};
    updates[shoeKey] = newQty;
    if (warrantyKey && warrantyKey !== 'null' && warrantyKey !== 'undefined' && currentWarrantyQty) {
      var wasCoveringAll = currentShoeQty > 1 && currentWarrantyQty >= currentShoeQty;
      if (wasCoveringAll || currentWarrantyQty > newQty) {
        updates[warrantyKey] = newQty;
      }
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      window.refreshCartUI(cart);
    })
    .catch(function(err) {
      setCartLoading(false);
      console.error('Error changing qty:', err);
    });
  };

  window.removeProtectionPlan = function(shoeKey, warrantyKey) {
    setCartLoading(true);

    var removeWarrantyPromise = Promise.resolve();
    if (warrantyKey && warrantyKey !== 'null' && warrantyKey !== 'undefined' && warrantyKey !== '') {
      var updates = {};
      updates[warrantyKey] = 0;
      removeWarrantyPromise = fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    }

    removeWarrantyPromise
      .then(function() {
        if (shoeKey && shoeKey !== 'null' && shoeKey !== 'undefined' && shoeKey !== '') {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: shoeKey,
              properties: { 'Protection Plan': '' }
            })
          }).then(function(res) { return res.json(); });
        } else {
          return fetch('/cart.js').then(function(res) { return res.json(); });
        }
      })
      .then(function(cart) {
        window.refreshCartUI(cart);
      })
      .catch(function(err) {
        setCartLoading(false);
        console.error('Error removing protection plan:', err);
      });
  };

  window.removeProtectionPlanProperty = window.removeProtectionPlan;

  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-trigger]')) {
      e.preventDefault();
      openCart();
    } else if (e.target.closest('#CloseCartDrawer') || e.target.closest('#CartDrawerOverlay')) {
      e.preventDefault();
      closeCart();
    }
  });

  // --- Search Drawer Toggles ---
  const searchDrawer = document.getElementById('SearchDrawer');
  const searchOverlay = document.getElementById('SearchDrawerOverlay');
  const searchTriggers = document.querySelectorAll('[data-search-trigger]');
  const closeSearchBtn = document.getElementById('CloseSearchDrawer');

  function openSearch() {
    if (!searchDrawer) return;
    searchDrawer.classList.remove('hidden', 'pointer-events-none');
    setTimeout(() => {
      searchOverlay?.classList.remove('opacity-0');
    }, 10);
  }

  function closeSearch() {
    if (!searchDrawer) return;
    searchOverlay?.classList.add('opacity-0');
    setTimeout(() => {
      searchDrawer.classList.add('hidden', 'pointer-events-none');
    }, 300);
  }

  window.openSearchDrawer = openSearch;
  window.closeSearchDrawer = closeSearch;

  searchTriggers.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openSearch();
  }));

  closeSearchBtn?.addEventListener('click', closeSearch);
  searchOverlay?.addEventListener('click', closeSearch);

  // --- ESC Key Modal Close ---
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCart();
      closeSearch();
    }
  });
});
